//refatorar essa parte ok?
import { Component, Directive, Input } from '@angular/core';
@Directive({
  selector: 'split-linhas-tabela',
  standalone: true,
})
export class LinhasTabelaDirective {}
@Component({
  selector: 'split-tabela',
  templateUrl: './tabela-padrao.component.html',
  styleUrls: ['./tabela-padrao.component.scss'],
})
export class TabelaPadraoComponent {}
